import { render, staticRenderFns } from "./Cggscx.vue?vue&type=template&id=bb5165a6"
import script from "./Cggscx.vue?vue&type=script&lang=js"
export * from "./Cggscx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports